// extracted by mini-css-extract-plugin
module.exports = {"main-container":"FeeCalculation_main-container__3ac-Z","text-blue":"FeeCalculation_text-blue__3T6DF","text-gray-striked":"FeeCalculation_text-gray-striked__7nI5m"};